export default __webpack_public_path__ + "static/media/green-circle.aafd35d2.svg";